var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16536 8.70703C3.16536 5.64645 5.64645 3.16536 8.70703 3.16536C11.7676 3.16536 14.2487 5.64645 14.2487 8.70703C14.2487 10.2011 13.6574 11.5572 12.6961 12.5538C12.6698 12.5742 12.6446 12.5964 12.6205 12.6205C12.5964 12.6446 12.5742 12.6698 12.5538 12.6961C11.5572 13.6574 10.2011 14.2487 8.70703 14.2487C5.64645 14.2487 3.16536 11.7676 3.16536 8.70703ZM13.1544 14.274C11.9355 15.249 10.3893 15.832 8.70703 15.832C4.772 15.832 1.58203 12.6421 1.58203 8.70703C1.58203 4.772 4.772 1.58203 8.70703 1.58203C12.6421 1.58203 15.832 4.772 15.832 8.70703C15.832 10.3893 15.249 11.9355 14.274 13.1544L17.1838 16.0642C17.493 16.3734 17.493 16.8746 17.1838 17.1838C16.8746 17.493 16.3734 17.493 16.0642 17.1838L13.1544 14.274Z",
    fill: "#1C1C1C",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.76dc6254e42c24c763a0df4c7ac0c3a2.svg";
export { ForwardRef as ReactComponent };